import {appValues} from 'appRoot/app.constants';

const NS = 'ErrorTracking'; // jshint ignore:line

declare global {
  interface Window {
    Raven?: any;
  }
}

class ErrorTracking{
  public report(error: any): void {
    if (window.Raven && window.Raven.captureException) {
      try {
        window.Raven.setRelease(appValues.VERSION); // TODO Move elsewhere to configure it only once?
        window.Raven.captureException(error);
        // If logging errors is causing an error, just swallow those
        // errors; attempting to log these errors might lock the browser
        // in an infinite loop.
      } catch (e) {
        console.error(e);
      }
    } else {
      console.info('Sentry - Raven not available to record error.');
    }

    try {
      const info = {
        version: appValues.VERSION,
        accountId: null as any,
        venueId: null as any,
      };
      try {
        if (window.localStorage) {
          const account = JSON.parse(window.localStorage.getItem('ngStorage-account'));
          const venue = JSON.parse(window.localStorage.getItem('ngStorage-venue'));
          if (account && account.id) {
            info.accountId = account.id;
          }
          if (venue && venue.id) {
            info.venueId = venue.id;
          }
        }
      } catch (e) {
        // Just failed to retrieve context info, no drama
      }

      // @todo: add a tracking service for errors
      // If logging errors is causing an error, just swallow those
      // errors; attempting to log these errors might lock the browser
      // in an infinite loop.
    } catch (e) {
      console.error(e);
    }
  }

  public setUserContext(user: {accountId: string;  name: string; venueId: number;}): void {
    if (window.Raven && window.Raven.setUserContext) {
      try {
        window.Raven.setUserContext(user);
      } catch (e) {
        console.error(e);
      }
    }
  }

}

const instance = new ErrorTracking();
export default instance as ErrorTracking;
